/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MeetingType {
    ShiftDeployment = 0,
    ShiftHandover = 1,
    ShiftCaptain = 2,
}
